import { IconButton } from '@assembly-js/design-system';

import { InvoiceActionRendererProps } from './types';

export const InvoiceActionRenderer = ({ data }: InvoiceActionRendererProps) => (
  <IconButton
    icon="ArrowRight"
    onClick={() => window.open(data.hosted_invoice_url, '_blank')}
    variant="minimal"
  />
);
